import { render, staticRenderFns } from "./CurationTermsModal.vue?vue&type=template&id=42a61299&scoped=true"
import script from "./CurationTermsModal.vue?vue&type=script&lang=js"
export * from "./CurationTermsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a61299",
  null
  
)

export default component.exports